import React, { useState, useEffect } from 'react';
import './Calendario.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { collection, doc, onSnapshot, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase/firebaseConfig';  // Importa o Firestore
import FormEvento from '../FormEvento/formEvento';
import { useFormContext } from '../../context/FormContext'; // Importar o contexto
import { useLocation, useParams } from "react-router-dom"; // Para pegar o token na URL

const Calendario = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const { formAberto, setFormAberto, setSelectedDate, eventoSelecionado, setEventoSelecionado } = useFormContext(); // Estado global do formulário
    const [eventos, setEventos] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const { token } = useParams();  // Pega o token da URL
    const location = useLocation();
    const [, setErro] = useState(null);
    const currentRoute = location.pathname;
    const isClientPortal = Boolean(token) || currentRoute.startsWith('/cliente');

    useEffect(() => {
        if (token) {

            // Aqui você busca os dados do token, como clientId e userEmail
            async function validarToken() {
                try {
                    const docRef = doc(db, 'tokens', token);
                    const docSnap = await getDoc(docRef); // Função getDoc agora está importada

                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        const clienteId = data.clienteId;
                        const emailAdvogado = data.userEmail;
                        setUserEmail(data.userEmail);





                        // Aqui você precisa garantir que o clienteAtual seja atualizado
                        setClienteSelecionado({ id: clienteId, email: emailAdvogado });  // Atualize o estado diretamente

                        // Buscar as mensagens do cliente com base no clienteId e userEmail
                        //buscarInboxPorCliente(clienteId, emailAdvogado);
                    } else {
                        setErro("Token inválido ou expirado.");
                    }
                } catch (error) {
                    console.error("Erro ao validar token: ", error);
                    setErro("Erro ao validar token.");
                }
            }


            validarToken();
        }
        if (!token) {
            setUserEmail(String(auth.currentUser.email));
        }
    }, [token]);

    // Função para buscar o cliente selecionado do sessionStorage
    const getClienteAtual = () => {
        const clienteSalvo = sessionStorage.getItem('clienteSelecionado');
        return clienteSalvo ? JSON.parse(clienteSalvo) : null;
    };

    useEffect(() => {
        if (!token) {
            setUserEmail(String(auth.currentUser.email));
            const intervalId = setInterval(() => {
                const cliente = getClienteAtual();
                setClienteSelecionado(cliente);
            }, 1000);  // Verifica a cada 1 segundo se o cliente mudou

            return () => clearInterval(intervalId);  // Limpa o intervalo quando o componente for desmontado
        }
    }, [token]);

    useEffect(() => {

        // Inicializa a coleção de eventos
        if (!userEmail) {
            setEventos([]);
            return;
        }

        const eventosCollection = collection(db, `usuarios/${userEmail}/eventos`);

        // Escuta as alterações em tempo real na coleção de eventos
        const unsubscribe = onSnapshot(eventosCollection, (eventosSnapshot) => {
            const eventosList = eventosSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            // Filtra eventos apenas para a área do cliente ou rota específica
            if (clienteSelecionado) {

                if (!token) {
                    const eventosFiltrados = currentRoute === '/areadocliente'
                        ? (clienteSelecionado ? eventosList.filter(evento => evento.clienteId === clienteSelecionado.id) : [])
                        : eventosList;

                    if (clienteSelecionado) {

                    }
                    setEventos(eventosFiltrados);
                }
                if (token) {


                    const eventosFiltrados = clienteSelecionado
                        ? eventosList.filter(evento => String(evento.clienteId) === String(clienteSelecionado.id))
                        : [];  // Se não houver cliente selecionado, retorna uma lista vazia



                    setEventos(eventosFiltrados);
                }
            }
            if (!clienteSelecionado) {
                setEventos(eventosList);

            }
        }, (error) => {
            console.error("Erro ao carregar eventos:", error);
        });

        return () => {
            unsubscribe(); // Cancela a escuta
        };
    }, [clienteSelecionado, currentRoute, token, userEmail]);

    const daysInMonth = (month, year) => {
        return new Date(year, month + 1, 0).getDate();
    };

    const nextMonth = () => {
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
    };

    const previousMonth = () => {
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
    };

    // Desabilita o clique no calendário se a rota for '/cliente'
    const handleClick = (dia, mes, ano) => {
        if (isClientPortal) {
            return; // Impede a interatividade quando a rota for /cliente
        }
        const dateString = `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
        setSelectedDate(dateString);
        setEventoSelecionado(null);
        setFormAberto(true); // Abre o formulário de edição
    };

    const goToToday = () => {
        const today = new Date();
        setCurrentMonth(today.getMonth());
        setCurrentYear(today.getFullYear());
    };

    const handleEventClick = (event, evento) => {
        event.stopPropagation();
        if (isClientPortal) {
            return;
        }

        setSelectedDate(evento.data);
        setEventoSelecionado(evento);
        setFormAberto(true);
    };

    const getEventColor = (color) => {
        const normalizedColor = String(color || '').toLowerCase();
        return ['', '#fff', '#ffffff'].includes(normalizedColor) ? '#bfdbfe' : color;
    };

    const renderDays = () => {
        const days = [];
        const totalDays = daysInMonth(currentMonth, currentYear);
        const today = new Date();
        const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

        // Índice do dia da semana do primeiro dia do mês atual
        const firstDayIndex = new Date(currentYear, currentMonth, 1).getDay();

        // Dias do mês anterior para preencher os espaços
        const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        const previousYear = currentMonth === 0 ? currentYear - 1 : currentYear;
        const totalDaysPreviousMonth = daysInMonth(previousMonth, previousYear);

        for (let i = firstDayIndex; i > 0; i--) {
            days.push(
                <div className="dia cinza" key={`prev-${i}`}>
                    <span className="dia-numero">{totalDaysPreviousMonth - i + 1}</span>
                </div>
            );
        }

        // Renderiza os dias reais do mês atual
        for (let i = 1; i <= totalDays; i++) {
            const dataParaComparacao = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;

            const eventosDoDia = eventos.filter(evento => evento.data === dataParaComparacao);
            const eventosVisiveis = eventosDoDia.slice(0, 2);
            const isToday = dataParaComparacao === todayString;

            days.push(
                <div
                    className={`dia ${isToday ? 'hoje' : ''} ${token ? 'disabled' : ''}`}
                    key={i}
                    onClick={() => handleClick(i, currentMonth, currentYear)}
                    style={token ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                >
                    <span className="dia-numero">{i}</span>
                    {eventosDoDia.length > 0 && (
                        <div className="container-eventos-dia">
                            {eventosVisiveis.map((evento, index) => (
                                <button
                                    key={evento.id || index}
                                    className="evento-calendario"
                                    style={{ backgroundColor: getEventColor(evento.cor) }}
                                    onClick={(event) => handleEventClick(event, evento)}
                                    title={evento.nome}
                                    type="button"
                                >
                                    {evento.hora && <span className="evento-hora">{evento.hora}</span>}
                                    <span className="evento-nome">{evento.nome}</span>
                                </button>
                            ))}
                            {eventosDoDia.length > eventosVisiveis.length && (
                                <span className="evento-mais">
                                    +{eventosDoDia.length - eventosVisiveis.length} compromisso{eventosDoDia.length - eventosVisiveis.length > 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        // Dias do próximo mês para completar a última linha
        const nextDays = 42 - days.length; // Assume um calendário de 6 linhas (42 células)
        for (let i = 1; i <= nextDays; i++) {
            days.push(
                <div className="dia cinza" key={`next-${i}`}>
                    <span className="dia-numero">{i}</span>
                </div>
            );
        }

        return days;
    };


    const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    return (
        <div className='main-container-calendario'>
            <div className='container-calendario'>
                <div className='calendario'>
                    <div className='container-mes'>
                        <div className="calendario-mes-copy">
                            <small>Visão mensal</small>
                            <span className='mes'>{monthNames[currentMonth]} {currentYear}</span>
                        </div>
                        <div className="calendario-toolbar">
                            <button className="btn-hoje" onClick={goToToday} type="button">
                                <FontAwesomeIcon icon={faCalendarDay} />
                                Hoje
                            </button>
                            <div className="grupo-navegacao-calendario">
                                <button className='btn-nav' onClick={previousMonth} aria-label="Mês anterior" title="Mês anterior" type="button">
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                <button className='btn-nav' onClick={nextMonth} aria-label="Próximo mês" title="Próximo mês" type="button">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='container-semana-dia'>
                        <div className='container-semana'>
                            <div className='semana'>Dom</div>
                            <div className='semana'>Seg</div>
                            <div className='semana'>Ter</div>
                            <div className='semana'>Qua</div>
                            <div className='semana'>Qui</div>
                            <div className='semana'>Sex</div>
                            <div className='semana'>Sáb</div>
                        </div>
                        <div className='container-dia'>
                            {renderDays()}
                        </div>
                    </div>
                </div>
            </div>
            {formAberto && !isClientPortal && (
                <FormEvento
                    //selectedDate={selectedDate}
                    eventoExistente={eventoSelecionado}
                //clienteId={clienteSelecionado.id} // Passa o CPF do cliente selecionado
                />
            )}
        </div>
    );
};

export default Calendario;
